/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'people.menu.renotify.flag.description':
    'Vi skickar en påminnelse till alla via e-post. Det kan ta upp till en minut.',
  'people.menu.renotify.flag.description.confluence': 'Påminn teammedlemmar',
  'people.menu.renotify.flag.title': 'Skickar påminnelser',
  'people.menu.renotify.flag.title.confluence': 'Skickar e-postmeddelandet med inbjudan på nytt',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} person har inte accepterat sin {product}-inbjudan. Ta reda på vem det är och skicka en påminnelse.} other {{userCount,number} personer har inte accepterat sina {product}-inbjudningar. Ta reda på vilka det är och skicka en påminnelse.}}',
  'people.menu.renotify.menu.description.confluence':
    'Vissa personer har inte accepterat sin Confluence-inbjudan. Ta reda på vilka det är och skicka en påminnelse.',
  'people.menu.renotify.menu.dismiss': 'Avfärda',
  'people.menu.renotify.menu.dismiss.confluence': 'Inte nu',
  'people.menu.renotify.menu.remind': 'Påminn teammedlemmar',
  'people.menu.renotify.menu.remind.confluence': 'Påminn teammedlemmar',
  'people.menu.renotify.menu.title': 'Är alla med?',
  'people.menu.renotify.modal.copied': 'Länken har kopierats',
  'people.menu.renotify.modal.copy': 'Kopiera inbjudningslänk',
  'people.menu.renotify.modal.description':
    'Vi kan skicka en påminnelse via e-post till de saknade medlemmarna eller så kan du dela inbjudningslänken själv.',
  'people.menu.renotify.modal.description.confluence':
    'Skicka e-postmeddelandet med inbjudan igen eller kopiera och dela via inbjudningslänken.',
  'people.menu.renotify.modal.dismiss': 'Avbryt',
  'people.menu.renotify.modal.resend': 'Skicka påminnelse',
  'people.menu.renotify.modal.resend.confluence': 'Skicka inbjudan på nytt',
  'people.menu.renotify.modal.title': 'Påminn saknade medlemmar',
  'people.menu.renotify.modal.title.confluence': 'Påminn teammedlemmar som saknas',
  'ptc.pm.collaborators.title': 'Dina medarbetare',
  'ptc.pm.error-heading': 'Något har gått fel',
  'ptc.pm.error-image-alt-text': 'En trasig robot och ett antal människor som försöker fixa den.',
  'ptc.pm.error-text':
    'Vi håller koll på dessa fel, men du får gärna kontakta oss om det inte hjälper att uppdatera sidan',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmar}}',
  'ptc.pm.people': 'Personer',
  'ptc.pm.teams': 'Team',
  'ptc.pm.view-your-profile': 'Visa din profil',
  'ptc.pm.your-teams.title': 'Dina team',
};
